"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const RactiveComponentPlugin_1 = require("auto-widget-framework/src/Plugin/RactiveComponent/RactiveComponentPlugin");
const DateSegments_1 = require("../../Enum/DateSegments");
const configs_1 = require("../../configs/configs");
const Ractive = require("ractive");
class DateInputComponent extends RactiveComponentPlugin_1.default {
    /**
     * @inheritDoc
     */
    getElementName() {
        return "date-input";
    }
    getComponent() {
        const onrender = this.onRender.bind(this);
        const getDatePart = this.getDatePart.bind(this);
        return Ractive.extend({
            isolated: true,
            template: this.definition.getTemplate(),
            onrender: function () { onrender(this); },
            getDatePart: function (dateSegment) { return getDatePart(this, dateSegment); }
        });
    }
    onRender(component) {
        this.dateField = component.find('[data-px-date-input]');
        this.dayField = component.find(this.getDatePartFieldSelector(component, '_day"]'));
        this.monthField = component.find(this.getDatePartFieldSelector(component, '_month"]'));
        this.yearField = component.find(this.getDatePartFieldSelector(component, '_year"]'));
        this.dayField.addEventListener('input', () => { this.onInputDatePart('input'); });
        this.monthField.addEventListener('input', () => { this.onInputDatePart('input'); });
        this.yearField.addEventListener('input', () => { this.onInputDatePart('input'); });
        this.yearField.addEventListener('blur', () => { this.onInputDatePart('blur'); });
    }
    onInputDatePart(eventType) {
        setTimeout(() => {
            this.dateField.value = this.yearField.value + "-" + this.monthField.value + "-" + this.dayField.value;
            let event;
            if (typeof (Event) === 'function') {
                event = new Event(eventType);
            }
            else {
                // IE and Edge.
                event = document.createEvent('Event');
                event.initEvent(eventType, true, true);
            }
            if (this.yearField.value.length >= 4 && this.monthField.value.length > 0 && this.dayField.value.length > 0) {
                this.dateField.dispatchEvent(event);
            }
            // Remove error message if all date inputs are empty.
            if (this.yearField.value.length === 0 && this.monthField.value.length === 0 && this.dayField.value.length === 0) {
                const errorContainer = document.querySelector(`[${configs_1.configs.elementIDs.QUESTIONNAIRE_QUESTION_ERRORS}="${this.dateField.name}"]`);
                errorContainer.innerHTML = "";
                /*TODO Refactor this behaviour to be used outside of questionnainre */
                errorContainer.classList.remove(configs_1.configs.utilityCSSClasses.isInvalid);
                this.yearField.classList.remove(configs_1.configs.utilityCSSClasses.isInvalid);
                this.monthField.classList.remove(configs_1.configs.utilityCSSClasses.isInvalid);
                this.dayField.classList.remove(configs_1.configs.utilityCSSClasses.isInvalid);
            }
        }, 50);
    }
    getDatePart(component, dateSegment) {
        const dateParts = (component.get('value') || '').split('-');
        return dateParts[DateSegments_1.DateSegments[dateSegment]] || '';
    }
    getDatePartFieldSelector(component, datePartSuffix) {
        return '[data-px-date-input="' + component.get('name') + datePartSuffix;
    }
}
exports.default = DateInputComponent;
